module.exports = __webpack_public_path__ + "img/suyuan2.ffc59b2b.png";